import React, { useState, useEffect } from "react";
import { createUseStyles } from "react-jss";

function HomepageHeader({ pageTitle, images }) {
  const [activeIndex, setActiveIndex] = useState(0);

  // Auto-rotate every 5s
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images.length]);

  const useStyles = createUseStyles({
    container: {
      height: "100%",
      width: "100%",
      position: "relative",
      overflow: "hidden",
    },
    pageTitle: {
      margin: 5,
      font: { size: 70 },
      textAlign: "center",
      color: "white",
    },
    motto: {
      fontSize: 20,
      marginTop: 5,
      fontStyle: "italic",
    },
    overlay: {
      position: "absolute",
      bottom: "60px",
      left: "50%",
      transform: "translateX(-50%)",
      textAlign: "center",
      color: "white",
      zIndex: 10,
    },
    "@media (max-width: 500px)": {
      pageTitle: {
        font: { size: 35 },
      },
    },
  });
  const styles = useStyles();

  return (
    <div className={styles.container}>
      {/* Background images */}
      <div className="relative w-full h-[700px]">
        {images.map((image, index) => (
          <img
            key={index}
            src={image.src}
            alt={image.alt}
            className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ${index === activeIndex ? "opacity-100" : "opacity-0"
              }`}
          />
        ))}
      </div>

      {/* Overlay text at bottom */}
      <div className={styles.overlay}>
        <h1 className={styles.pageTitle}>{pageTitle}</h1>
        <blockquote className={styles.motto}>
          "<strong>Transforming Lives</strong>"
        </blockquote>
      </div>

      {/* Line indicators */}
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-2">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            aria-label={`Go to slide ${index + 1}`}
            className={`h-1 w-8 rounded-full transition-all ${index === activeIndex ? "bg-white" : "bg-gray-500/60"
              }`}
          />
        ))}
      </div>
    </div>
  );
}

export default HomepageHeader;
